import { Organization } from '../global';
import { ORGANIZATION_SEARCH_RESULT, OrganizationData } from './types';

export const organization = (
  state: OrganizationData = {},
  action: {
    type: string;
    payload?: Organization[];
  }
): OrganizationData =>
  action.type === ORGANIZATION_SEARCH_RESULT ? { ...state, organizations: action.payload } : state;
